export const DischargeAmountType = {
  Percent: 'Percent',
  Unit: 'Unit',
};
